import * as Sentry from '@sentry/react'
import { useEffect } from 'react'

import { useSession } from '@/contexts/auth/session'

import { useUser } from '../auth/user'

export function SentryUserProvider({
  children,
}: {
  children: React.ReactNode
}) {
  const { user } = useUser()

  const {
    state: { isUserAuthenticated },
  } = useSession()

  useEffect(() => {
    if (!user) {
      Sentry.setUser(null)
      return
    }

    Sentry.setUser({
      id: user._id,
      email: user.email,
      username: user.name,
    })
  }, [user, isUserAuthenticated])

  return <>{children}</>
}
